import { Spinner } from '@alkem/react-ui-spinner';
import { LazyTooltip } from '@alkem/react-ui-tooltip';
import classNames from 'classnames';
import { MouseEvent, ReactNode } from 'react';
import ReactTooltip from 'react-tooltip';
import { v4 as uuid } from 'uuid';
import Button from './react-ui-button';
import './react-ui-icon-button.scss';

type ButtonMouseEvent = MouseEvent<any>;

interface IconButtonProps {
  disabled?: boolean;
  onClick?: (mouseEvent: ButtonMouseEvent) => void | any;
  mdiIcon: string;
  testid?: string;
  primary?: boolean;
  secondary?: boolean;
  secondaryDarker?: boolean;
  className?: string;
  displaySpinner?: boolean;
  tooltipLabel?: String;
  tooltipPlace?: ReactTooltip['props']['place'];
  children?: ReactNode;
}

const IconButton = ({
  mdiIcon,
  children,
  className,
  disabled = false,
  testid,
  displaySpinner = false,
  onClick,
  tooltipLabel,
  tooltipPlace = 'bottom',
  primary = false,
  secondary = false,
  secondaryDarker = false,
}: IconButtonProps) => {
  const button = (
    <Button
      disabled={disabled}
      onClick={onClick}
      className={classNames('IconButton', {
        'IconButton--disabled': disabled,
        'IconButton--primary': primary,
        'IconButton--secondary': secondary,
        'IconButton--secondary-darker': secondaryDarker,
      })}
      testid={testid}
    >
      {(displaySpinner && (
        <Spinner
          className="IconButton__spinner"
          loading
          primary={primary}
          secondary={secondary}
          small
        />
      )) ||
        (!!mdiIcon && (
          <>
            <i className={`mdi mdi-${mdiIcon}`} />
            {children}
          </>
        ))}
    </Button>
  );

  return (
    <div className={classNames('IconButton--container', className)}>
      {(tooltipLabel && (
        <LazyTooltip
          id={`icon-button-tip-${uuid()}`}
          tooltipLabel={tooltipLabel}
          place={tooltipPlace}
        >
          {button}
        </LazyTooltip>
      )) ||
        button}
    </div>
  );
};

export default IconButton;
